import { ClearValidation, ExtraInfoFilterId } from 'app/area/administration/shared/types';
import { FilterOption } from 'app/components/options-handler/types';
import { ValidationProps } from 'ui';

export const validationToBooleanValues = (
  validation: { [key: string]: ValidationProps }
): { [key: string]: boolean } => {
  const keys = !!validation && Object.keys(validation);
  return (!!keys && keys.length > 0)
    ? keys.reduce((acc, key) => {
      const node = validation[key];
      const messages = !!node && node.messages;
      acc[key] = messages && messages.length > 0;
      return acc;
    }, {})
    : undefined;
};

export const validationHighlights = (
  properties: string[],
  validationErrors: { [key: string]: boolean }
) => !(validationErrors && properties && Array.isArray(properties)
  && properties.some(key => !!validationErrors[key as any]));

export const validationPrefixHighlights = (
  prefixes: string[],
  validationErrors: { [key: string]: boolean }
) => !(prefixes && validationErrors && prefixes.some(prefix =>
  Object.keys(validationErrors).some(key => key.includes(`${prefix}_`) && !!validationErrors[key])));

export const fetchingOptions = (options: { [key: string]: FilterOption } = {}) =>
  Object.keys(options).some(key => !!options[key]?.fetching);

export const getExtraInfoFilterId = (id: number, type: ExtraInfoFilterId) => `extraInfo_${type}_${id}`;

export const clearValidationFactory = (
  formName: string,
  clearValidation: ClearValidation
) => () => clearValidation(formName, undefined);
